import {Injectable} from "@angular/core";
import {StorageKeysEnum} from "../../storage/storage-keys.enum";
import * as jwt from "jose"
import {UserInfo} from "../../models/user-info.model";

@Injectable({ providedIn: 'root' })
export class UserUtilsService {

  getContractUserSelected() {
    const userInfoString: any = sessionStorage.getItem(StorageKeysEnum.USER_INFO);
    const userInfo = userInfoString ? JSON.parse(userInfoString) : {};
    const contractSelected = Array.isArray(userInfo?.contrato) ? userInfo?.contrato[0] : userInfo.contrato;
    return contractSelected?.idContrato;
  }

  getUserInfoSessionStorage() {
    const userInfoString: any = sessionStorage.getItem(StorageKeysEnum.USER_INFO);
    return userInfoString ? JSON.parse(userInfoString) : {}
  }

  getUserContractInfoSessionStorage(): UserInfo {
    const userInfoString: any = sessionStorage.getItem(StorageKeysEnum.USER_INFO);
    const userInfo = userInfoString ? JSON.parse(userInfoString) : {};
    return Array.isArray(userInfo?.contrato) ? userInfo?.contrato[0] : userInfo.contrato;

  }

  getPersonId():any {
    const wsoToken = sessionStorage.getItem("ACCESS_TOKEN_WSO") ?? ""
    const jwtDecoded = jwt.decodeJwt(wsoToken);
    return jwtDecoded ? jwtDecoded['idPersona'] : "";
  }

  getCveUser():any {
    const wsoToken = sessionStorage.getItem("ACCESS_TOKEN_WSO") ?? ""
    const jwtDecoded = jwt.decodeJwt(wsoToken);
    return jwtDecoded ? jwtDecoded['usuario'] : "";
  }
  /**
   * @param dataToUpdate objeto que se inserta en el USER_INFO en sessionStorage
   */
  setUserInfoSessionStorage(dataToUpdate: { [key: string]: any }) {
    const userInfoString: any = sessionStorage.getItem(StorageKeysEnum.USER_INFO);
    const userInfo = userInfoString ? JSON.parse(userInfoString) : {};
    const updatedUserInfo = { ...userInfo, ...dataToUpdate };
    sessionStorage.setItem(StorageKeysEnum.USER_INFO, JSON.stringify(updatedUserInfo));
  }


  calculateInitials() {
    const userInfo = this.getUserInfoSessionStorage()
    const names = userInfo?.fullName.split(' ');
    const firstInitial = names[0][0].toUpperCase();
    let lastInitial = names[1] ? names[1][0].toUpperCase() : '';
    if (names.length > 3) {
      lastInitial = names[2][0].toUpperCase();
    }
    return `${firstInitial}${lastInitial}`;
  }
}
